var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddRowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 31,
    viewBox: "0 0 35 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 31,
    rx: 10,
    fill: "#C2DCF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8752 16.1237H12.7085C12.5314 16.1237 12.383 16.0638 12.2633 15.9439C12.1434 15.824 12.0835 15.6756 12.0835 15.4985C12.0835 15.3213 12.1434 15.1729 12.2633 15.0533C12.383 14.9336 12.5314 14.8737 12.7085 14.8737H16.8752V10.707C16.8752 10.5299 16.9351 10.3815 17.055 10.2618C17.1748 10.142 17.3233 10.082 17.5004 10.082C17.6776 10.082 17.826 10.142 17.9456 10.2618C18.0653 10.3815 18.1252 10.5299 18.1252 10.707V14.8737H22.2918C22.4689 14.8737 22.6173 14.9336 22.737 15.0535C22.8569 15.1734 22.9168 15.3218 22.9168 15.4989C22.9168 15.6761 22.8569 15.8245 22.737 15.9441C22.6173 16.0638 22.4689 16.1237 22.2918 16.1237H18.1252V20.2904C18.1252 20.4674 18.0652 20.6159 17.9454 20.7356C17.8255 20.8554 17.677 20.9154 17.5 20.9154C17.3227 20.9154 17.1743 20.8554 17.0547 20.7356C16.935 20.6159 16.8752 20.4674 16.8752 20.2904V16.1237Z",
    fill: "#304674"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddRowIcon);
export default __webpack_public_path__ + "static/media/add-row-icon.117d30ea0296477bd2f4b2474ab1455f.svg";
export { ForwardRef as ReactComponent };